import CookiePanel from './cookiePanel';

export default CookiePanel;